export default { type: 'spring', mass: 1.3 };
